// @ts-nocheck

import { useState } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { MobileNavButton } from './components/MobileNavButton';
import { MobileNavigationProps } from './MobileNavigation.types';
import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle, Logo } from '@goed/ui-components';
import { useReactiveVar } from '@apollo/client';
import { cartVarUld, isLoggedInVar, userInfoVar } from '@goed-platform/shared/data-access';
import { RoutesEnum } from '@goed-platform/shared/types';

const getHrefFromArray = (arrayOfSlugs: string[]) => {
    return arrayOfSlugs.join('/');
};

export const MobileNavigation: React.FC<MobileNavigationProps> = ({
    visible,
    onClickClose,
    items,
}: MobileNavigationProps): JSX.Element => {
    const isAuthenticated = useReactiveVar(isLoggedInVar);
    const userInfo = useReactiveVar(userInfoVar);
    const [activeLevel, setActiveLevel] = useState<number>(0);
    const [breadcrumbs, setBreadcrumbs] = useState<number[]>([]);
    const [slug, setSlug] = useState<string[]>([]);
    const cartUld = useReactiveVar(cartVarUld);
    const windowSize = useWindowSize();

    if (!visible) return <></>;

    if (windowSize.width > 768) {
        onClickClose();
    }

    const handleClickClose = (event: any) => {
        setActiveLevel(0);
        onClickClose(event);
    };

    return (
        <Dialog open={visible} onOpenChange={handleClickClose}>
            <DialogContent className="mobile-nav" background="primary" type="drawer">
                <DialogHeader className="mobile-nav__header">
                    <DialogTitle className="u-sr-only">Goed</DialogTitle>
                    <Logo variant="light" className="mobile-nav__logo" />
                    <DialogClose variant="box" />
                </DialogHeader>
                <div
                    className="mobile-nav__levels"
                    style={{ transform: `translateX(-${activeLevel * 100}%) translateZ(0)` }}
                >
                    <div className="mobile-nav__level mobile-nav__level--main">
                        <ul className="mobile-nav__primary">
                            {items.items.map((item, i) => (
                                <li key={`mobile-primary-${i}`}>
                                    {'__typename' in item &&
                                    (item.__typename === 'ExternalLinkRecord' ||
                                        item.__typename === 'InternalLinkRecord') ? (
                                        <MobileNavButton
                                            title={item?.label ?? ''}
                                            slug={item.url ?? '/'}
                                            openInNewWindow={item.openInNewWindow}
                                            iconAfter="arrow-up-right"
                                        />
                                    ) : (
                                        <>
                                            {item.links.map((link, i) => (
                                                <MobileNavButton
                                                    key={i}
                                                    title={link?.label ?? ''}
                                                    slug={link.url ?? '/'}
                                                    openInNewWindow={link.openInNewWindow}
                                                    iconAfter="arrow-up-right"
                                                />
                                            ))}
                                        </>
                                    )}
                                </li>
                            ))}
                        </ul>
                        <ul className="mobile-nav__secondary">
                            <li>
                                <MobileNavButton
                                    variant="secondary"
                                    title="terug naar webshop"
                                    slug="https://aanbod.goed.be"
                                    iconAfter="arrow-up-right"
                                    openInNewWindow
                                />
                            </li>
                            <li>
                                <MobileNavButton
                                    iconBefore="shopping"
                                    variant="secondary"
                                    title="categoriën"
                                    slug={RoutesEnum.rentalStoreLanding}
                                    openInNewWindow
                                />
                            </li>
                            <li>
                                <MobileNavButton
                                    variant="secondary"
                                    title={isAuthenticated ? `${userInfo?.firstName}` : 'inloggen'}
                                    slug={isAuthenticated ? RoutesEnum.account : RoutesEnum.login}
                                    iconBefore="user"
                                />
                            </li>
                            <li>
                                <MobileNavButton
                                    variant="secondary"
                                    title="openstaande reservaties"
                                    slug={RoutesEnum.rentalStoreCart}
                                    iconBefore="shopping-basket"
                                    count={cartUld?.totalQuantity}
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
